/*
 * Copyright (C) 2026 The Android Open Source Project
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
package com.bikompanion.ui.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.addPathNodes
import androidx.compose.ui.unit.dp

val MaterialBikeDock: ImageVector
    get() {
        if (_MaterialBikeDock != null) return _MaterialBikeDock!!

        _MaterialBikeDock = ImageVector
            .Builder(
                name = "bike_dock",
                defaultWidth = 24.dp,
                defaultHeight = 24.dp,
                viewportWidth = 960f,
                viewportHeight = 960f,
            ).apply {
                addPath(
                    pathData = addPathNodes(
                        "M120,840L120,760L290,711L352,191Q356,161 378,140.5Q400,120 431,120L529,120Q560,120 582," +
                            "140.5Q604,161 608,191L670,711L840,760L840,840L120,840ZM440,720L520,720L520,240Q520," +
                            "223 508.5,211.5Q497,200 480,200Q463,200 451.5,211.5Q440,223 440,240L440,720Z",
                    ),
                    fill = SolidColor(Color.Black),
                )
            }.build()

        return _MaterialBikeDock!!
    }

private var _MaterialBikeDock: ImageVector? = null
